export default "<ng-container *ngTemplateOutlet=\"currentView\"></ng-container>\r\n"